import React from 'react';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import { CAMPAIGN_GOALS } from '@/lib/configs/campaigns';
import { CUSTOM_DATE_FORMAT } from '@/lib/constants/common';
import translate from '@/lib/intl/translate';
import CampaignType from '@/propTypes/CampaignType';
import { formatCurrency } from '@/utils/currency';
import { formatDate } from '@/utils/dates';
import formatWebAddress from '@/utils/formatWebAddress';
import { formatUrl } from '@/utils/urls';
import ContentBody from './ContentBody';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
function CampaignContent({ campaign }: any) {
  const { assignees, goals, url, startDate, endDate } = campaign;

  let goalAmount;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
  let goalType: any;
  let goalConfig;
  let stretchAmount;

  // Currently the UI design only supports one goal, may change in the future
  if (goals?.length) {
    goalAmount = goals[0].goalAmount;
    goalType = goals[0].goalType;
    stretchAmount = goals[0].stretchAmount;
    goalConfig = CAMPAIGN_GOALS.find((config) => config.value === goalType);
  }

  const contentItems = [
    url && {
      title: translate('CAMPAIGN_DETAILS_WEBSITE'),
      value: (
        <Link
          className="truncate font-medium"
          href={formatUrl(url)}
          rel="noopener noreferrer"
          target="_blank"
          variant="body1"
        >
          {formatWebAddress(url)}
        </Link>
      ),
      className: 'col-span-full',
    },
    {
      title: translate('CAMPAIGN_DETAILS_GOAL_TYPE'),
      icon: goalConfig?.icon,
      value: goalConfig?.text,
    },
    {
      title: translate('CAMPAIGN_DETAILS_GOAL'),
      value: formatCurrency(goalAmount, true),
    },
    {
      title: translate('CAMPAIGN_DETAILS_STRETCH_GOAL'),
      value: formatCurrency(stretchAmount, true),
    },
    {
      title: translate('CAMPAIGN_DETAILS_START_DATE'),
      value: formatDate(startDate, CUSTOM_DATE_FORMAT),
    },
    {
      title: translate('CAMPAIGN_DETAILS_END_DATE'),
      value: formatDate(endDate, CUSTOM_DATE_FORMAT),
    },
  ].filter(Boolean);

  return (
    <ContentBody
      assignees={assignees}
      assigneeTitle={translate('CAMPAIGN_DETAILS_ADMINISTRATORS')}
      contentItems={contentItems}
      entityId={campaign.campaignId}
      title={translate('CAMPAIGN_DETAILS')}
    />
  );
}

CampaignContent.propTypes = {
  campaign: PropTypes.shape(CampaignType).isRequired,
};
export default CampaignContent;
